// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"18ba75dd","453":"7d718bb5","732":"91439e5a","977":"fadcf02c"}[chunkId] + ".chunk.js";
};